<template>
  <div>
    <report/>
  </div>
</template>

<script>
import Report from '@/components/Report'

export default {
  name: 'Reports',
  components: {
    Report
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
